import React, { useState } from "react";
import { FileSpreadsheet, ChevronDown, Database } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { handleExportError } from "../ExportApprovalStatus";

// Owner-only accounting workbook download (authenticated request → blob; no public URL).
export default function ExportButton({ params, rangeLabel }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const download = async (p, label) => {
    setOpen(false); setBusy(true);
    try {
      const r = await api.get("/accounting/export.xlsx", { params: p, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      const cd = r.headers["content-disposition"] || "";
      const m = cd.match(/filename\*=UTF-8''([^;]+)/);
      a.href = url; a.download = m ? decodeURIComponent(m[1]) : `imdad_accounting_${label}.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("تم تنزيل ملف Excel");
    } catch (e) { await handleExportError(e); } finally { setBusy(false); }
  };
  return (
    <div className="relative" data-testid="export-menu">
      <button onClick={() => setOpen((o) => !o)} disabled={busy} data-testid="export-excel-btn"
        className="h-11 px-4 rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white font-extrabold text-sm flex items-center gap-2 disabled:opacity-60">
        <FileSpreadsheet size={18} /> {busy ? "جارٍ التحضير…" : "تصدير Excel"} <ChevronDown size={14} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-2 right-0 w-72 bg-white border border-[#DCEBEE] rounded-xl shadow-xl overflow-hidden" data-testid="export-options">
            <button onClick={() => download(params, "period")} data-testid="export-current-period" className="w-full text-right px-4 py-3 hover:bg-[#F5FAFB] border-b border-[#EBF4F6]">
              <div className="font-bold text-[#333333] text-sm flex items-center gap-2"><FileSpreadsheet size={16} className="text-emerald-700" /> الفترة المعروضة حالياً</div>
              <div className="text-xs text-[#777777] mt-0.5">{rangeLabel || "—"}</div>
            </button>
            <button onClick={() => download({ period: "all" }, "all")} data-testid="export-all-data" className="w-full text-right px-4 py-3 hover:bg-[#F5FAFB]">
              <div className="font-bold text-[#333333] text-sm flex items-center gap-2"><Database size={16} className="text-[#09637E]" /> كل البيانات</div>
              <div className="text-xs text-[#777777] mt-0.5">كامل سجل أعمالك في إمداد — نسخة محمولة لجهازك</div>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
